import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DragDropModule } from '@angular/cdk/drag-drop';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  NgModule,
  NO_ERRORS_SCHEMA,
  provideAppInitializer,
} from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { InputsModule } from '@lc/ui';
import { PreloadAllModules, RouterModule } from '@angular/router';
import {
  AppService,
  AuthGuard,
  CannyService,
  CoreModule,
  DataDogLogger,
  FeatureFlags,
  FeatureGuard,
  IFeatureGuardData,
  initializeApp,
  LaunchDarklyService,
  StartupService,
  StateModule,
} from '@lc/core';
import { SurveyResponseFormModule } from '@re-surveys/ui-ng';
import { UserIdleConfig, UserIdleModule } from 'angular-user-idle';
import { SharedComponentsUiModule } from '@lc/shared-components-ui';
import { AppComponent } from './app.component';
import { ServiceNowChatComponent } from './service-now-chat/service-now-chat.component';

if (location.hostname !== 'localhost' && location.hostname !== 'remotedev') {
  DataDogLogger.initialize('pub7f8f31a15154517d03fd6111b8de6851');
  DataDogLogger.initializeDDRealUserMonitoring('pub7f8f31a15154517d03fd6111b8de6851');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    DragDropModule,
    InputsModule,
    SharedComponentsUiModule.forRoot(),
    SurveyResponseFormModule,
    RouterModule.forRoot(
      [
        {
          path: '',
          loadChildren: () => import('@lc/lc-app-ui').then((m) => m.LcAppUiModule),
        },
      ],
      {
        enableTracing: false,
        paramsInheritanceStrategy: 'always',
        preloadingStrategy: PreloadAllModules,
        scrollPositionRestoration: 'enabled',
        bindToComponentInputs: true,
      },
    ),
    CoreModule.forRoot(),
    StateModule,
    UserIdleModule,
    ServiceNowChatComponent,
  ],
  exports: [InputsModule],
  providers: [
    provideAppInitializer(() => {
      const initializerFn = (initializeApp)(inject(StartupService));
      return initializerFn();
    }),
    { provide: APP_BASE_HREF, useValue: '/' },
    // User activity timeouts
    // Ping value is not used
    // Session timeout is pulled from AppSettings after load.  If not found default is 5 minutes
    {
      provide: UserIdleConfig,
      useFactory: () => ({ idle: AppService.get('sessionTimeout') * 60, timeout: 30, ping: 10000 }),
    },
    LaunchDarklyService,
    CannyService,
    FeatureGuard,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {}
